import { PaginationTypes } from "modules/congregation/action";

export type ActionType = {
  type: string;
  payload: any;
};

export class LoginFormModal {
  email: string = "";
  password: string = "";
}

export type APIResponseModal = {
  data: any;
  message: any;
  isSuccess: boolean;
};

export class Pagination {
  page: number = 1;
  limit: number = 10;
  totalPages: number = 1;
  totalRecords: number = 1;
}

export class SortBy {
  sortedBy: string = "";
  sortOrder: string = "";
}

// Reducer Model
export type ReducersModal = {};

class CityState {
  id: number = 0;
  name: string = "";
}
// congregation Modal
export type CongregationItemType = {
  id: number;
  state: CityState;
  city: CityState;
  name: string;
  zipcode: string;
};

class PaginationSchema {
  page: PaginationTypes = {
    page: 1,
    limit: 10,
    search: "",
    totalPages: 0,
    totalRecords: 0,
    sortedBy: "createdAt",
    sortOrder: 1,
  };
  isLoading: boolean = false;
  count: number = 0;
}
class States extends PaginationSchema {
  result: Array<{ id: number; name: string }> = [];
  page: PaginationTypes = {
    page: 1,
    limit: 10,
    search: "",
    totalPages: 0,
    totalRecords: 0,
    sortedBy: "createdAt",
    sortOrder: 1,
  };
  isLoading: boolean = false;
  count: number = 0;
}
export class Congregation extends PaginationSchema {
  result: CongregationItemType[] = [];
  allStates: States = new States();
  allCities: States = new States();
}

export class RequestedCongregation extends PaginationSchema {
  result: CongregationItemType[] = [];
}
export class CongregationState {
  congregations: Congregation = new Congregation();
  requestCongregation: RequestedCongregation = new RequestedCongregation();
}
export type UserDataItem = {
  id: number;
  userType: string;
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
  profilePhoto: string;
  gender: string;
  congregationId: number;
  token: null;
  isAvailable: boolean;
  availableTill: null;
  blocked: boolean;
  blockedAt: null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
};

export class Users {
  result: UserDataItem[] = [];
  page: PaginationTypes = {
    page: 1,
    limit: 10,
    search: "",
  };
  isLoading: boolean = false;
  count: number = 0;
}
export class UserState {
  users: Users = new Users();
}
